<template>
  <el-container>
    <el-header height="40px">
      <el-form :inline="true" class="header-form">
        <el-form-item label="模板名称：">
          <el-input v-model="queryParam.SearchValue" placeholder="请输入模板名称" style="width: 140px"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="queryParam.Status" placeholder="全部" style="width: 90px" clearable>
            <el-option label="全部" :value="undefined" />
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item class="header-add-btn">
          <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd">新增模板</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <grid-table ref="gridTable" :tableConfig="tableConfig" :showIndexColumn="false" :showCheckboxColumn="false"
        :showLastEmptyColumn="false" :showPagination="true">
        <template slot="PageSize" slot-scope="{ params }">
          {{ params.row.PageWidth }}mm × {{ params.row.PageHeight }}mm
        </template>
        <template slot="Status" slot-scope="{ params }">
          <el-tag :type="params.row.Status === 1 ? 'success' : 'info'" size="small">
            {{ params.row.Status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
        <template slot="CreteTime" slot-scope="{ params }">
          {{ params.row.CreteTime | dateFormat }}
        </template>
        <template slot="ModifyTime" slot-scope="{ params }">
          {{ params.row.ModifyTime | dateFormat }}
        </template>
        <template slot="OP" slot-scope="{ params }">
          <el-button type="text" @click.stop="handleEdit(params.row)">编辑</el-button>
          <el-button type="text" style="color: #f56c6c" @click.stop="handleDelete(params.row)">删除</el-button>
        </template>
      </grid-table>
    </el-main>

  </el-container>
</template>

<script>
import { submit } from '@/api/base'

export default {
  name: 'PrintTemplate',
  data() {
    return {
      tableConfig: {
        url: '/api/printTemplate/getPageList',
        rowKey: 'ID',
        columns: [
          { label: '模板名称', prop: 'Name', type: 'text' },
          { label: '纸张规格', prop: 'PageSize', type: 'custom-operation' },
          { label: '状态', prop: 'Status', type: 'custom-operation' },
          { label: '创建日期', prop: 'CreteTime', type: 'custom-operation' },
          { label: '更新日期', prop: 'ModifyTime', type: 'custom-operation' },
          { label: '创建人', prop: 'Creator', type: 'text' },
          { label: '操作', prop: 'OP', type: 'custom-operation' },
        ],
      },
      queryParam: {
        SearchValue: '',
        Status: undefined,
      },
    }
  },
  mounted() {
    this.handleQuery()
  },
  methods: {

    // 查询列表
    handleQuery() {
      // 构建grid-table需要的查询参数
      const searchParam = {}
      if (this.queryParam.SearchValue) {
        searchParam.Name = this.queryParam.SearchValue
      }
      if (this.queryParam.Status !== undefined && this.queryParam.Status !== '') {
        searchParam.Status = this.queryParam.Status
      }
      this.$refs.gridTable.searchParam = searchParam
      this.$refs.gridTable.fetchData(false, null, this.$refs.gridTable.searchParam)
    },

    // 重置
    reset() {
      this.queryParam.SearchValue = ''
      this.queryParam.Status = undefined
      this.handleQuery()
    },

    // 新增
    handleAdd() {
      console.log("新建模板", this.$router)
      const url = this.$router.resolve({
        path: '/print-template-editor',
        query: { action: 'add' },
      }).href
      window.open(url, '_blank')
    },

    // 编辑
    handleEdit(row) {
      const url = this.$router.resolve({
        path: '/print-template-editor',
        query: { action: 'add', id: row.ID },
      }).href
      window.open(url, '_blank')
    },

    // 删除
    handleDelete(row) {
      this.$baseConfirm(`确定要删除模板【${row.Name}】吗？删除后不可恢复。`, '删除确认', () => {
        this.doDelete(row.ID)
      })
    },

    async doDelete(id) {
      try {
        const { success } = await submit(`/api/printTemplate/delete?id=${id}`)
        if (success) {
          this.$message.success('删除成功')
          this.handleQuery()
        }
      } catch (e) {
        console.error('删除模板失败', e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-header {
    height: 40px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px 10px 0 !important;

    .el-form {
      .el-form-item {
        margin-bottom: 5px !important;
      }
    }
  }

  .el-main {
    border-top: 0px !important;
    margin-top: 5px !important;
  }
}

// ========== 表头布局样式 ==========
.header-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  .el-form-item {
    margin-bottom: 5px;
    margin-right: 10px;
  }

  // 新增模板按钮容器 - 推到最右侧
  .header-add-btn {
    margin-left: auto;
    margin-right: 10px;
  }
}
</style>